var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"title":"کاردکس","color":"cyan","disabled":!_vm.wareId},on:{"click":_vm.openInventory}},[_vm._v("fa-pallet")])
}
var staticRenderFns = []

export { render, staticRenderFns }